import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

import {HandoverModel} from "@handover/view-models/handover.model";

@Component({
  selector: 'handoverm-handover-top-label',
  templateUrl: './handover-top-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoverTopLabelComponent implements OnInit {

  @Input() model?: HandoverModel;

  constructor() {
  }

  ngOnInit(): void {
  }

}
